import { z } from 'zod';

export const userPurchaseStatsSchema = z.object({
  has_orders: z.boolean(),
  eligible_for_trial: z.boolean().optional(),
});

export type UserPurchaseStats = z.infer<typeof userPurchaseStatsSchema>;
